import request from '@/utils/request'
import {_download} from "../utils/request";

let OrderApi = {
  /*订单列表*/
  orderlist(data, errorback) {
    return request._postBody('/supplier/order/index', data, errorback);
  },
  /*订单详情*/
  orderdetail(data, errorback) {
    return request._post('/supplier/order/detail', data, errorback);
  },
  /*售后管理*/
  orderrefund(data, errorback) {
    return request._postBody('/supplier/order/refund/index', data, errorback);
  },
  /*去发货*/
  delivery(data, errorback) {
    return request._postBody('/supplier/order/delivery', data, errorback);
  },
  /*确认审核*/
  confirm(data, errorback) {
    return request._postBody('/supplier/order/operate/confirmCancel', data, errorback);
  },
  /*售后详情*/
  refundDetail(data, errorback) {
    return request._get('/supplier/order/refund/detail', data, errorback);
  },
  /*售后审核*/
  Approval(data, errorback) {
    return request._postBody('/supplier/order/refund/audit', data, errorback);
  },
  /*确认收货并退款*/
  receipt(data, errorback) {
    return request._postBody('/supplier/order/refund/receipt', data, errorback);
  },
  /*核销*/
  extract(data, errorback) {
    return request._postBody('/supplier/order/operate/extract', data, errorback);
  },
  /*修改价格*/
  updatePrice(data, errorback) {
    return request._postBody('/supplier/order/updatePrice', data, errorback);
  },
  /*批量发货*/
  batchDelivery(formData, errorback) {
    return request._upload('/supplier/order/operate/batchDelivery', formData, errorback);
  },
  /*取消订单*/
  orderCancel(formData, errorback) {
    return request._postBody('/supplier/order/orderCancel', formData, errorback);
  },
  /*取消订单*/
  orderClose(formData, errorback) {
    return request._postBody('/supplier/order/orderClose', formData, errorback);
  },
  orderOpen(formData, errorback) {
    return request._postBody('/supplier/order/orderOpen', formData, errorback);
  },
  /*虚拟设备发货*/
  virtual(formData, errorback) {
    return request._upload('/supplier/order.order/virtual', formData, errorback);
  },
  updateAddress(data, errorback) {
    return request._postBody('/supplier/order/updateAddress', data, errorback);
  },
  /*分销订单*/
  agentOrder(data, errorback) {
    return request._postBody('/supplier/order/agent/index', data, errorback);
  },
  orderDownload(data, filename,config, errorback) {
    return request._download('/supplier/order/operate/export', data, filename, config, errorback);
  },
}

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/order.js